import { useMemo } from 'react';
import { getSuperbarTheme, type SuperbarTheme } from '../themes/theme';
import { useChatContext } from '../context/use-chat-context';

export const useSuperbarTheme = (): SuperbarTheme => {
  const { mode } = useChatContext();
  return useMemo(() => {
    return getSuperbarTheme(mode);
  }, [mode]);
};
